import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFlipkartComponent } from './simple-icons-flipkart.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFlipkartComponent ],
    exports:      [ SimpleIconsFlipkartComponent ],
    bootstrap:    []
})
export class SimpleIconsFlipkartModule {}
